export const DEFAULT_MEAL_VOUCHERS_TOTAL_VALUE = 8
export const DEFAULT_MEAL_VOUCHERS_CONTRIBUTION_VALUE = 1.09
